import React from "react";

const Badge = ({ type = "success", className = "", children }) => {
  return (
    <span
      className={`custom-badge custom-badge-${type} text-capitalize ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
